import { useEffect, useRef, type ReactNode } from "react";

/** Diálogo acessível: o foco entra no diálogo e volta ao elemento de origem. Só fecha pelo botão (Cancelar/Fechar/✕): clicar fora ou apertar Esc NÃO fecha, para não perder o que foi digitado. */
export function Modal({ title, onClose, children, wide }: { title: string; onClose: () => void; children: ReactNode; wide?: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const prev = document.activeElement as HTMLElement | null;
    ref.current?.querySelector<HTMLElement>("input,select,textarea,button")?.focus();
    return () => { prev?.focus?.(); };
  }, []);
  return (
    <div className="modal-back">
      <div className={`modal${wide ? " wide" : ""}`} role="dialog" aria-modal="true" aria-label={title} ref={ref}>
        <div className="modal-head"><h3>{title}</h3><button className="top-icon" onClick={onClose} aria-label="Fechar">✕</button></div>
        {children}
      </div>
    </div>
  );
}
